import { AppRouteProps } from "@bsm/component";
import { PublicHolidayContainer } from "./container/PublicHolidayContainer";
import { PublicHolidayCreateRoutes } from "./views/create/PublicHolidayCreateRoutes";

export const PublicHolidayRoutes: Array<AppRouteProps> = [
    {
        path: "public-holiday",
        title: "BSMRH.Holiday.Title.SchoolHolidays",
        element: <PublicHolidayContainer />,
        children: [
            ...PublicHolidayCreateRoutes
        ]
    }
];